<template>
  <div class="prior">
    <video
      v-if="quiz && media == 'mp4'"
      id="video"
      width="100%"
      height="100%"
      playsinline
      autoplay
      muted
      @ended="ended"
    >
      <source :src="require(`@/assets/Q${quiz}.mp4`)" type="video/mp4" />
    </video>
    <figure v-if="media == 'png'">
      <img :src="require(`@/assets/Q${quiz}.png`)" />
    </figure>
  </div>
</template>

<script>
import SessionMixin from "./../mixins/SessionCookieMixin";
import Questions from "./../questions";
import bus from "./../bus";
export default {
  mixins: [SessionMixin],
  data() {
    return {
      quiz: null,
      media: null,
    };
  },

  methods: {
    ended() {
      const vm = this;
      const quiz = this.quiz;
      const max = process.env.VUE_APP_NB_QUIZ;
      console.log("vidéo terminée");
      if (quiz >= max) {
        this.$router.push({ name: "Comment" });
        return;
      } else {
        this.$router.push({ name: "Question" });
      }
    },
  },

  mounted() {
    const record = this.fetchSession();
    const quiz = parseInt(this.$route.params.quiz) || record["Quiz"];
    let session = this.$cookies.get("bci_session");
    session["Quiz"] = quiz;
    this.$cookies.set("bci_session", session);
    this.quiz = quiz;
    console.log("Quiz:", quiz);
    bus.$emit("quizUpdated", quiz);
    const question = Questions[quiz];
    const media = question["Media"];
    this.media = media;

    if (typeof media == "undefined") {
      this.$router.push({ name: "Question" });
    }
    if (media == "png") {
      const vm = this;
      setTimeout(function () {
        vm.$router.push({ name: "Question" });
      }, 2000);
    }
  },
};
</script>
